import React, { useEffect } from "react";
import { Navigation, Contacto, Footer, PageSEO } from "@/App";

const ContactoPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PageSEO
        title="Contacto | AYCES - Consultor Actuarial en México"
        description="Contacta a AYCES para estudios actuariales, valuación de pasivos laborales, cálculos actuariales de pensiones y cumplimiento NIF D-3, IAS 19 y US GAAP."
        path="/contacto/"
      />
      <Navigation />
      <main className="pt-20">
        <Contacto />
      </main>
      <Footer />
    </>
  );
};

export default ContactoPage;
